export default {
  insertAssessmentScore: '/business/assessmentScore/insertAssessmentScore',
  updateAssessmentScore: '/business/assessmentScore/updateAssessmentScore',
  deleteAssessmentScore: '/business/assessmentScore/deleteAssessmentScore',
  selectAssessmentScoreByScoreId: '/business/assessmentScore/selectAssessmentScoreByScoreId',
  selectAssessmentScoreList: '/business/assessmentScore/selectAssessmentScoreList',
  selectAssessmentScoreByPage: '/business/assessmentScore/selectAssessmentScoreByPage',
  insertAssessmentResult: '/business/assessmentResult/insertAssessmentResult',
  deleteAssessmentResult: '/business/assessmentResult/deleteAssessmentResult',
  selectAssessmentResultByResultId: '/business/assessmentResult/selectAssessmentResultByResultId',
  selectAssessmentResultByPage: '/business/assessmentResult/selectAssessmentResultByPage',
  selectLcAssessmentIssueByPage: '/business/LcAssessmentIssue/selectLcAssessmentIssueByPage',
  exportAssessmentResult: '/business/assessmentResult/exportAssessmentResult'
}
